export const MAP_TYPES = Object.freeze({
  TABLE: 'table',
  QUERY: 'query',
  TILESET: 'tileset'
});

export const API_VERSIONS = Object.freeze({
  V1: 'v1',
  V2: 'v2',
  V3: 'v3'
});
